<template>
    <ol>
        <slot></slot>
    </ol>
</template>
<script>
    export default {
        name: "TechnologyArticleList"
    }
</script>